import { type ZodType, type ZodTypeDef, z } from "zod";

export type KeyFieldsLockOptions = {
	lockKeyFields?: boolean;
};

export const lockableField = <TOutput, TInput>(
	schema: ZodType<TOutput, ZodTypeDef, TInput>,
	locked: boolean,
): ZodType<TOutput | undefined, ZodTypeDef, TInput> =>
	locked ? z.custom<TInput>().transform(() => undefined) : schema;
